import Game from './scenes/Game';
import Intro from './scenes/Intro';
import Questions from './scenes/Questions';
import Results from './scenes/Results';
import Select from './scenes/Select';
import Title from './scenes/Title';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
  */
  scenes: [Title, Select, Questions, Intro, Game, Results],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
  */
  startScene: Title.KEY,

  GT: 'GreaterThan',
  LT: 'LessThan',
  EQ: 'Equals',
  GAMETYPE_WHOLE_NUMBERS: 0,
  GAMETYPE_FRACTIONS: 1,
  GAMETYPE_DECIMALS: 2,
  GAMETYPE_MIXED: 3,
  GAMETYPE_JR: 4,
  GAMELEVEL_EASY: 0,
  GAMELEVEL_MEDIUM: 1,
  GAMELEVEL_HARD: 2,
  GAME_TYPE: 'regular',// 'jr'
  LEVEL_TIME: 60,

  correctCount: 0,
  totalAnswered: 0,
  coinScore: 0,
  gametype: 3,
  gamelevel: 0,
  coinmode: 'odd',
  queueBusy: false,
  queueCompleteHandler: null,
};
